module.exports = __webpack_public_path__ + "img/first-zh.38069ec2.png";